<div class="container-fluid">
  <div class="row" [hidden]="!(canCreateDocument || isUploadFile || isEditing)">
    <div class="col-md-12">
      <div class="card h-auto mb-4" #formCard>
        <div class="card-header bg-light">
          <h4 class="card-title">{{ (isEditing || isUploadFile) ? 'Edit Document' : 'Request New Document' }}</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="documentsForm" (ngSubmit)="onSubmit()">
            <div class="row mb-3">
              <div [ngClass]="!isEditing || isUploadFile ? 'col-md-4' : 'col-md-6'">
                <input-field [inputFormControl]="getDescription()" label="Description Document Needed"
                  type="text" placeholder="Enter document description" [readonly]="isUploadFile">
              </input-field>
            </div>
            @if (!isEditing || isUploadFile) {
              <div class="col-md-4">
                <div class="custom-file-upload" >
                  <label class="form-label">Choose File</label>
                  <label for="documentFile" class="btn btn-outline-primary w-100">
                    <i class="fa fa-file me-2"></i>{{ selectedFile ? 'Change File' : 'Choose File' }}
                  </label>
                  @if (selectedFile) {
                    <div class="selected-file mt-2">
                      <small class="text-success"><i class="fa fa-check-circle me-1"></i>{{ selectedFile.name }}</small>
                    </div>
                  }
                  @if (!selectedFile) {
                    <div class="selected-file mt-2">
                      <small class="text-muted">No file selected</small>
                    </div>
                  }
                  <input type="file" class="visually-hidden" id="documentFile"
                    #fileInput
                    (change)="onFileSelected($event)">
                </div>
              </div>
            }
            <div [ngClass]="!isEditing || isUploadFile ? 'col-md-4' : 'col-md-6'">
              <textarea-field [textareaFormControl]="getComment()" label="Comment" [height]="60" [placeholder]="'Comment'" [readonly]="isUploadFile && canCreateDocument"/>
            </div>
          </div>
          <div class="row">
            <div class="d-flex gap-2" [ngClass]="isEditing ? 'col-md-6' : 'col-md-3'">
              <button type="submit" class="btn btn-success me-2">
                <i class="fa fa-save me-2"></i>{{ isEditing ? 'Update' : 'Save' }}
              </button>
              @if (isEditing) {
                <button type="button" class="btn btn-secondary"
                  (click)="cancelEdit()">
                  <i class="fa fa-times me-2"></i>Cancel
                </button>
              }
              @if (isUploadFile) {
                <button type="button" class="btn btn-secondary"
                  (click)="cancelCustomerUploadFile()">
                  <i class="fa fa-times me-2"></i>Cancel
                </button>
              }
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  </div>

  <div class="col-md-12">
    <div class="card">
      <div class="card-header bg-light">
        <h4 class="card-title">Requested Documents</h4>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Description</th>
                <th>File</th>
                <th>Comment</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (doc of documents; track doc) {
                <tr>
                  <td>
                    <div class="document-description">
                      <div class="doc-text">{{ doc.documentNeeded }}</div>
                      @if (doc?.requestedUser) {
                        <div class="doc-meta">
                          @if (doc.requestedTime) {
                            <small class="text-muted">
                              Request inserted at <span class="user-info">{{ formatDate(doc.requestedTime) }}</span>
                              @if (getRequestedUserName(doc)) {
                                <span class="user-info">
                                  by {{ getRequestedUserName(doc) }}
                                </span>
                              }
                            </small>
                          }
                        </div>
                      }
                    </div>
                  </td>
                  <td>
                    <div class="document-file">
                      <div class="doc-text">
                        @if (doc.attachments) {
                          <span class="me-2">{{ doc.attachments[0]?.fileNameOriginal }}</span>
                        }
                        @if (!doc.attachments) {
                          <span>No file uploaded</span>
                        }
                      </div>
                      @if (doc?.uploadedUser) {
                        <div class="doc-meta">
                          @if (doc.uploadedTime) {
                            <small class="text-muted">
                              File submitted at <span class="user-info">{{ formatDate(doc.uploadedTime) }}</span>
                              @if (getUploadedUserName(doc)) {
                                <span class="user-info">
                                  by {{ getUploadedUserName(doc) }}
                                </span>
                              }
                            </small>
                          }
                        </div>
                      }
                    </div>
                  </td>
                  <td>{{ doc.comment }}</td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-2">
                      @if (doc.attachments?.length > 0) {
                        <button
                          class="btn btn-outline-secondary btn-sm"
                          (click)="downloadFile(doc.attachments[0])"
                          title="Download file">
                          <i class="fa fa-solid fa-download"></i>
                        </button>
                      }
                      @if (!(doc.attachments?.length > 0)) {
                        <button
                          class="btn btn-outline-warning btn-sm"
                          (click)="startCustomerUploadFile(doc)"
                          title="Upload file"
                          [disabled]="isEditing || isUploadFile">
                          <i class="fa fa-upload"></i>
                        </button>
                      }
                      @if (canCreateDocument) {
                        <button type="button"
                          class="btn btn-outline-primary btn-sm"
                          (click)="startEdit(doc)"
                          title="Edit document"
                          [disabled]="isEditing || isUploadFile">
                          <i class="fa fa-edit"></i>
                        </button>
                      }
                      @if (canDeleteDocument) {
                        <button type="button"
                          class="btn btn-outline-danger btn-sm"
                          (click)="openDeleteConfirmation(doc.projectCustomerDocumentId)"
                          title="Delete document"
                          [disabled]="isEditing || isUploadFile">
                          <i class="fa fa-trash"></i>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
              @if (documents.length === 0) {
                <tr>
                  <td colspan="4" class="text-center">No documents found</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (documents.length > 0 && canSendRequestToClient) {
          <div class="d-flex justify-content-center mt-3">
            <button type="button" class="btn btn-primary"
              (click)="sendRequestToClient()"
              [disabled]="isEditing || isUploadFile"
              title="Send request to client">
              <i class="fa fa-paper-plane me-2"></i>Send request to client
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>